module.exports = __webpack_public_path__ + "public/images/calendar-arrow.de1bde609edd1b31a71024319c5be1e2.svg";